import { render } from "./company-result.vue?vue&type=template&id=870d0f9a&scoped=true"
import script from "./company-result.vue?vue&type=script&lang=js"
export * from "./company-result.vue?vue&type=script&lang=js"

import "./company-result.vue?vue&type=style&index=0&id=870d0f9a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-870d0f9a"]])

export default __exports__